<template src="./reportsPage.html"></template>

<script>
import rightButtonMenu from '../../../components/RightButtonMenu/rightButtonMenu.vue';
import titlePage from './tabComponents/titlePage/titlePage.vue';
import faultsPage from './tabComponents/faultsPage/faultsPage.vue';
import plotsPage from './tabComponents/plotsPage/plotsPage.vue';
import defectsPage from './tabComponents/defectsPage/defectsPage.vue';
import additionalPage from './tabComponents/additionalPage/additionalPage.vue'
import manholePage from './tabComponents/manholePage/manholePage.vue';
import videoPage from './tabComponents/videoPage/videoPage.vue';
import observationsEndpoints from '../../observations/observations.endpoints';
import reportEndpoints from '../reports.endpoints';
import reportMixin from '../../../js/reportMixin';

export default {
    name: 'reports-page',
    mixins: [reportMixin],
    components: {
        'right-button-menu': rightButtonMenu,
        'title-page': titlePage,
        'faults-page': faultsPage,
        'plots-page': plotsPage,
        'defects-page': defectsPage,
        'additional-page': additionalPage,
        'manhole-page': manholePage,
        'video-page': videoPage
    },
    data() {
        return {
            selectedTab: 'TitlePage',
            observationsDetails: [],
            faultsObservations: [],
            headerOptionsAndValues: [],
            reportHeaders: {},
            headerFields: { text: 'LabelText', value: 'LabelText' },
            sessionFields: [],
            unsavedHeaderChanges: false
        };
    },
    computed: {
        // currentSelectedTab() {
        //     return this.$store.state.ReportsModule.activeTab;
        // },
        userIsEditUser() {
            return (
                this.$store.state.AuthorizationModule.SignedInUser.Role != 'Guest' &&
                this.$store.state.AuthorizationModule.SignedInUser.Role != 'View-Only'
            );
        },
        session() {
            return this.$store.state.SessionsModule.Session;
        },
        sessionTemplate() {
            if (this.$store.state.SessionsModule.Session) {
                return this.$store.state.SessionsModule.Session.TemplateName;
            }

            return '';
        },
        showDefectTab() {
            if (this.sessionTemplate && this.sessionTemplate.toLowerCase().includes('posm')) {
                return false;
            }

            return true;
        },
        showManholeTab() {
            if (this.sessionTemplate && this.sessionTemplate.toUpperCase().includes('MACP')) {
                return true;
            }

            return false;
        },
        rightMenuButtons() {
            return [
                {
                    text: 'View Observations',
                    icon: 'fa-search',
                    color: 'brand-color-primary',
                    onClick: this.navigateToObservationForSession,
                    isVisible: true,
                },
                {
                    text: this.userIsEditUser ? 'Edit Headers' : 'View Headers',
                    icon: 'fa-list',
                    color: 'brand-color-alternate-1',
                    onClick: this.navigateToHeadersForSession,
                    isVisible: true,
                },
                {
                    text: this.userIsEditUser ? 'Edit Report Headers' : 'View Report Headers',
                    icon: 'fa-file-text-o',
                    color: 'brand-color-alternate-2',
                    onClick: this.toggleSidebar,
                    isVisible: true,
                },
            ];
        },
    },
    methods: {
        changeTab(selectedTab) {
            this.selectedTab = selectedTab;
        },
        btnSaveHeadersOnClick() {
            return reportEndpoints.updateHeaders(this.reportHeaders)
                .then(() => {
                    this.unsavedHeaderChanges = false;
                    this.toggleSidebar();
                })
        },
        btnCloseHeadersOnClick() {
            if (this.unsavedHeaderChanges) {
                let message = 'You have unsaved changes. Are you sure you want to close?';
                let title = 'Confirm';
                DMUtils.confirmShow(message, title, this.toggleSidebar, null, 'Yes', 'No');
            } else {
                this.toggleSidebar();
            }
        },
        toggleSidebar() {
            this.$refs.editReportHeaders.toggle();
        },
        navigateToHeadersForSession() {
            this.$store.commit('SessionsModule/setNavigatedToHeadersFrom', 'reports');
            this.$router.push({ name: 'headers', query: { id: this.$route.query.id } });
        },
        navigateToObservationForSession() {
            this.$store.commit('SessionsModule/setNavigatedToHeadersFrom', 'reports');
            this.$router.push({ name: 'observations', query: { id: this.$route.query.id } });
        },
        setUnsavedHeaderChanges(args, value) {
            this.unsavedHeaderChanges = value;
        },
        getHeaders() {
            reportEndpoints
                .getReportHeadersNameAndValue(this.session.SessionID)
                .then((response) => {
                    this.headerOptionsAndValues = response;
                    return reportEndpoints.getHeaders(this.sessionTemplate);
                })
                .then((response) => {
                    this.reportHeaders = response;
                    
                });
        },
        getObservationDetails() {
            return this.$store
                .dispatch('ObservationModule/getObservations', this.$route.query.id)
                .then(() => {
                    let observations = this.$store.state.ObservationModule.Observations;
                    const promises = observations.map((obs, index) => {
                        return observationsEndpoints.getObservationByID(obs.ObservationID).then((response) => {
                            response.FaultCode = obs.FaultCode;
                            response.MaintWeight = obs.MaintWeight;
                            response.StructWeight = obs.StructWeight;
                            this.observationsDetails.push(response);
                        });
                    });

                    return Promise.all(promises);
                })
                .then(() => {
                    this.setObservationsForFaults();
                    this.getHeaders();
                    this.flattenSessionPages();
                });
        },
        setObservationsForFaults() {
            this.observationsDetails.forEach((obs) => {
                if (obs.Images.length === 0) {
                    this.faultsObservations.push(obs);
                    return;
                }

                //For each observation, create a new observation for each image
                for (let i = 0; i < obs.Images.length; i++) {
                    let additionalImageObservation = DMUtils.copy(obs);

                    if (i > 0) {
                        additionalImageObservation.PictureNumber = i + 1;
                    }

                    additionalImageObservation.Images = obs.Images.slice(i, i + 1);
                    this.faultsObservations.push(additionalImageObservation);
                }
            });
        },
        flattenSessionPages() {
            let pages = this.$store.state.SessionsModule.Session.SessionPages;
            let flattened = [];

            pages.forEach((page) => {
                page.Fields.forEach((field) => {
                    flattened.push(field);
                });
            });

            this.sessionFields = flattened;
        },
    },
    created() {
        //this.$store.commit('ReportsModule/setActiveTab', 'TitlePageTab');
        this.$store.dispatch('getTemplates');
        this.$store.dispatch('SessionsModule/getSessionByID', this.$route.query.id).then(() => {
            this.getObservationDetails();
        });
    },
};
</script>
